import { render, staticRenderFns } from "./import-tracking.vue?vue&type=template&id=4bc7b956&scoped=true&"
import script from "./import-tracking.vue?vue&type=script&lang=js&"
export * from "./import-tracking.vue?vue&type=script&lang=js&"
import style0 from "./import-tracking.vue?vue&type=style&index=0&id=4bc7b956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7b956",
  null
  
)

export default component.exports